import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { push } from 'connected-react-router';

class Header extends Component {
    constructor(props){
        super(props);
        this.state = {
            opened: false
        };
    }

    handleMenuClick = () => {
        this.setState(prevState => ({
            opened: !prevState.opened
        }))
    };

    handleLogout = () => {
        const { dispatch } = this.props;
        this.setState({
            opened: false
        });
        dispatch(push('/logout'));
    };

    render(){
        const { user, businessInfo } = this.props;
        const { opened } = this.state;

        return (
            <div className="menu">
                <div className="branding">
                    <Link to="/"><img src="/images/logo.svg" alt="efundex" style={{ height: "65px"}}/></Link>
                </div>
                { user &&
                    <div className="account-link">
                        <div className="links-detail" style={{ cursor: "pointer" }} onClick={this.handleMenuClick}>
                            <span style={{display: "inline-block", verticalAlign: "middle" }}>
                                <span className="menu-mail" style={{ display: "block" }}>{ user }</span>
                                { businessInfo &&
                                    <span className="menu-comany-name">{ businessInfo.legalName }</span>
                                }
                            </span>
                        </div>
                    </div>
                }
                { opened &&
                    <div className="sub-menu" style={{ display: "block", position: "absolute", top: "70px", zIndex: 1, background:"white", border:"1px solid lightGray", padding: "10px 30px", right: "60px"}}>
                        <a className="logout" onClick={this.handleLogout} style={{ color: "#F28C1D", fontSize: "15px"}}>Logout</a>
                    </div>
                }
            </div>
        )
    }
}

const mapStateToProps = ( state ) => ({
    user: state.auth.user,
    businessInfo: state.app.businessInfo
});

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.jsx